<template>
    <section class="main">
        <div v-show="isLoading">
            <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <v-page-header :title="getPageTile" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                    <p class="text-center">
                        {{ loadingError }}
                    </p>
                </div>
            </div>

            <div v-show="!hasLoadingError">
                <div class="grid-container">
                    <div class="grid-x">
                        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                            <div class="wrapper">
                                <v-action-buttons :items="getActionButtons" @actionClicked="onClickAction" />

                                <div class="box">
                                    <div class="filter filter--media">
                                        <div class="grid-x grid-margin-x">
                                            <div class="cell medium-6 large-7">
                                                <p v-html="$t('media.description')"></p>
                                                <div class="form-group form-group--check">
                                                    <label class="small"><input type="checkbox" name="select_all" v-model="uploadsSelectAll" @change="onSelectAllMedia" /> <i></i> {{ $t('select_all' )}}</label>
                                                </div>
                                            </div>
                                            <div class="cell medium-6 large-5">
                                                <div class="form-group form-group--right">
                                                    <label for="form-element-sort" class="small">{{ $t('media.selected_files') }}</label>
                                                    <select id="form-element-sort" class="form-control form-control--small form-control--select" v-model="uploadsAction" @change="onChangeAction">
                                                        <template v-if="$store.getters.userHasPermission('project_media_delete')">
                                                            <option value="delete">{{ $t('delete') }}</option>
                                                        </template>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <v-blocks id="media" :isLoading="uploadsTableLoading" :items="uploadsTableItems" :useDeactivatedSwitch="false">
                                        <template slot="block" slot-scope="{ row }">
                                            <div class="form-group form-group--check">
                                                <label>
                                                    <input type="checkbox" name="upload[]" :value="row.id" v-model="uploadsTableItemsSelected[row.id]"> <i></i>
                                                </label>
                                                <div class="media media--block">
                                                    <template v-if="row.type[0] === 'image'">
                                                        <a :href="row.path" target="_blank" class="media--block__thumbnail" :style="'background-image: url(' + row.path + ');'">{{ row.filename }}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a :href="row.path" target="_blank" class="media--block__thumbnail" :class="row.type[1]">{{ row.filename }}</a>
                                                    </template>
                                                    <div class="media--block__content">
                                                        <p class="title"><strong>{{ row.filename }}</strong></p>
                                                        <p>{{ row.comment }}</p>
                                                    </div>
                                                </div>
                                                <button class="button button--action button--action--edit button--small" :title="$t('update')" @click="onUploadObject('update', row)">
                                                    {{ $t('update') }}
                                                </button>
                                            </div>
                                        </template>
                                    </v-blocks>
                                    <v-pagination :currentPage="uploadsTableCurrentPage" :itemsPerPage="uploadsTableItemsPerPage" :items="uploadsTableItemsCount" @pageClicked="onChangeUploadsTablePage" />
                                    <v-upload-dialog :projectId="$route.params.project" :method="upload.method" v-model="upload.media" :isVisible="upload.isVisible" @onAction="onChangeUpload" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from '../../partials/PageHeader';
    import PageLoading from '../../partials/PageLoading';
    import ActionButtons from './../../partials/Foundation/ActionButtons';
    import Navigation from './../Navigation';

    import Blocks from './../../partials/Foundation/Blocks';
    import Pagination from './../../partials/Foundation/Pagination';
    import UploadDialog from './../../partials/UploadDialog';

    export default {
        data() {
            return {
                loading                     : false,
                loadingError                : null,
                customerObject              : {
                    id                          : 0
                },
                uploadsTableLoading         : true,
                uploadsTableCurrentPage     : 1,
                uploadsTableItemsPerPage    : 16,
                uploadsTableItems           : [],
                uploadsTableItemsCount      : 0,
                uploadsTableItemsSelected   : {},
                uploadsAction               : '',
                uploadsSelectAll            : false,
                upload                      : {
                    isVisible                   : false,
                    method                      : 'create',
                    media                       : {}
                }
            };
        },
        components : {
            vPageHeader             : PageHeader,
            vPageLoading            : PageLoading,
            vActionButtons          : ActionButtons,
            vNavigation             : Navigation,
            vBlocks                 : Blocks,
            vPagination             : Pagination,
            vUploadDialog           : UploadDialog
        },
        computed : {
            isLoading : function () {
                return this.loading;
            },
            hasLoadingError : function () {
                return this.loadingError !== null;
            },
            getPageTile : function () {
                if (this.customerObject.company_name) {
                    return this.customerObject.company_name;
                }

                return this.$t('project.media.title');
            },
            getActionButtons : function () {
                var buttons = [];

                if (this.$store.getters.userHasPermission('project_media_create')) {
                    buttons.push({
                         action : 'upload'
                     });
                }

                return buttons;
            }
        },
        created : function () {
            this.onUpdateCustomer();
        },
        methods : {
            onUpdateCustomer : function() {
                this.loadingError = null;

                if (!this.$route.params.customer) {
                    this.onUpdateUploadsTableItems();
                } else {
                    let promise = this.$api.clearParams()
                        .get('customers/' + this.$route.params.customer + '/get');

                    promise.then((response => {
                        this.customerObject = response.data.data;

                        this.onUpdateUploadsTableItems();
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onChangeUploadsTablePage : function (page) {
                this.uploadsTableCurrentPage = page;

                this.onUpdateUploadsTableItems();
            },
            onUpdateUploadsTableItems : function () {
                let promise = this.$api.clearParams()
                    .setPageParams(this.uploadsTableCurrentPage, this.uploadsTableItemsPerPage)
                    .addParam('project_id', this.$route.params.project)
                    .get('uploads');

                promise.then((response => {
                    this.uploadsTableItems          = response.data.data;
                    this.uploadsTableItemsCount     = response.data.meta.pagination.total;

                    this.uploadsTableItems.forEach((function (upload, index) {
                        upload.type = upload.file_type.split('/');
                        upload.path = process.env.VUE_APP_MEDIA_URL + upload.path.replace(/^\/|\/$/g, '');
                    }).bind(this));

                    this.uploadsTableLoading        = false;
                }).bind(this)).catch((error => {
                    this.uploadsTableLoading        = false;
                }).bind(this));

                this.uploadsTableLoading = true;
            },
            onClickAction : function (action) {
                switch (action) {
                    case 'upload':
                        this.onUploadObject('create');

                        break;
                }
            },
            onUploadObject : function (method, media) {
                if (media) {
                    media = {
                        id          : media.id,
                        project_id  : media.project_id,
                        file        : {
                            name        : media.filename
                        },
                        comment     : media.comment
                    };
                }

                this.upload = {
                    isVisible   : true,
                    method      : method,
                    media       : media || {}
                };
            },
            onChangeUpload : function (action, method) {
                switch (action) {
                    case 'upload':
                        this.onChangeUploadsTablePage(1);

                        break;
                }

                this.upload = {
                    isVisible   : false,
                    method      : 'create',
                    media       : {}
                };
            },
            onChangeAction : function (event) {
                switch (event.currentTarget.value) {
                    case 'delete':
                        this.onDeleteSelectedMedia();

                        break;
                }
            },
            onDeleteSelectedMedia : function () {
                var selected = this.getSelectedMedia();

                if (selected.length >= 1) {
                    let promise = this.$api.clearParams()
                        .post('uploads/delete', {
                            files : selected
                        });

                    promise.then((response => {
                        this.onResetUploadsFilter();
                        this.onUpdateUploadsTableItems(1);
                    }).bind(this)).catch((error => {
                        console.log(error);
                    }).bind(this));

                    this.uploadsTableLoading = true;
                } else {
                    this.onResetUploadsFilter();
                    this.onChangeUploadsTablePage(1);
                }
            },
            onSelectAllMedia : function (event) {
                var selected = {};

                this.uploadsTableItems.forEach((function (upload) {
                    if (event.currentTarget.checked) {
                        selected[upload.id] = true;
                    }
                }).bind(this));

                this.uploadsTableItemsSelected = selected;
            },
            getSelectedMedia : function () {
                var selected = [];

                for (var key in this.uploadsTableItemsSelected) {
                    if (this.uploadsTableItemsSelected[key] === true) {
                        selected.push(parseInt(key));
                    }
                }

                return selected;
            },
            onResetUploadsFilter : function () {
                this.uploadsAction              = '';
                this.uploadsSelectAll           = false;
                this.uploadsTableItemsSelected  = {};
            }
        }
    }
</script>